import React from "react";
import { useFlywireCallback } from "./hooks/useFlywireCallback";
import { FlywireCallback } from "../../modules/payment/Payment/components/PaymentPlanLine/components/PaymentGateway/Flywire/FlywireCallback/FlywireCallback";
import { developOptions } from "../../../config/developOptions";
import DevelopOptionsPanel from "../../shared/components/DevelopOptionsPanel";
import ResponsiveLayout from "../../shared/components/ResponsiveLayout";
import FlowLoadingWindowManager from "../../shared/sharedKernel/FlowLoadingWindowManager";
import LogoContainer from "../../shared/components/LogoContainer";
import { Box } from "@material-ui/core";
import { HeaderButtons } from "../../shared/components/HeaderButtons";

export const FlywireCallbackView = ({ forceDevOptionsPanel }) => {
  const { paymentPlanLineId } = useFlywireCallback();

  return (
    <div style={{ height: "100%" }}>
      {(developOptions.SHOW_DEV_OPTIONS || forceDevOptionsPanel) && (
        <DevelopOptionsPanel />
      )}
      <ResponsiveLayout>
        <FlowLoadingWindowManager />
        <LogoContainer appStarted={true} />
        <Box
          height={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          flexGrow={1}
        >
          <HeaderButtons />
          <FlywireCallback paymentPlanLineId={paymentPlanLineId} />
        </Box>
      </ResponsiveLayout>
    </div>
  );
};
